import React, { useEffect, useState } from "react";
import GlassPanel from "@/components/GlassPanel";
import api from "@/lib/api";
import { Mars, Venus } from "lucide-react";

export default function RecordHolders() {
  const [records, setRecords] = useState([]);

  useEffect(() => {
    api.get("/record-holders").then((r) => setRecords(r.data.records || []));
  }, []);

  // Group by test
  const grouped = records.reduce((acc, r) => {
    (acc[r.test] ||= {})[r.gender] = r;
    return acc;
  }, {});
  const tests = Object.keys(grouped);

  return (
    <div className="max-w-7xl mx-auto px-6 md:px-12 py-16" data-testid="record-holders-page">
      <div className="gps-tag mb-4">PEAK PERFORMANCE</div>
      <h1 className="gps-heading text-4xl md:text-6xl">RECORD HOLDERS</h1>
      <p className="text-mute max-w-2xl mt-6">
        The top male and female performer on every GPS test — derived from
        <span className="text-white"> admin-verified score logs only</span>. Submissions still
        pending review are excluded until a GPS administrator confirms the result.
      </p>

      <GlassPanel className="mt-6 p-5 flex flex-wrap items-center justify-between gap-4" data-testid="get-verified-cta">
        <div>
          <div className="gps-label">WANT YOUR SCORE ON THIS BOARD?</div>
          <div className="text-white text-sm mt-1">
            Each individual scan can be verified by the GPS team — typically when tested in-person at a partner gym or event.
          </div>
        </div>
        <a href="mailto:verify@gps.io?subject=GPS%20Score%20Verification%20Request" className="gps-btn" data-testid="request-verification">
          REQUEST VERIFICATION
        </a>
      </GlassPanel>

      <div className="grid sm:grid-cols-2 gap-4 mt-10">
        {tests.map((testName) => {
          const m = grouped[testName].M;
          const f = grouped[testName].F;
          return (
            <GlassPanel key={testName} className="p-6 glow-hover" data-testid={`record-${testName.replace(/\s+/g, "-").toLowerCase()}`}>
              <div className="flex items-center justify-between mb-4">
                <h3 className="gps-heading text-xl text-white">{testName.toUpperCase()}</h3>
                <span className="gps-tag">TOP HOLDERS</span>
              </div>
              <div className="hud-divider mb-4" />

              {[m, f].map((r) =>
                r && r.athlete ? (
                  <div key={r.gender} className="flex items-center gap-4 py-3 border-b border-white/5 last:border-b-0">
                    <div className="w-9 h-9 grid place-items-center border border-white/30">
                      {r.gender === "M" ? <Mars size={16} /> : <Venus size={16} />}
                    </div>
                    <div className="flex-1 min-w-0">
                      <div className="gps-heading text-white truncate">{r.athlete?.toUpperCase()}</div>
                      <div className="text-mute text-[10px] gps-mono tracking-[0.18em] truncate">
                        {(r.gym || "—") + " · " + (r.city ? `${r.city}, ` : "") + (r.country || "")}
                      </div>
                    </div>
                    <div className="text-right">
                      <div className="big-numeric text-white text-lg">{r.display_value}</div>
                    </div>
                  </div>
                ) : (
                  <div key={r?.gender || Math.random()} className="flex items-center gap-4 py-3 border-b border-white/5 last:border-b-0 opacity-50">
                    <div className="w-9 h-9 grid place-items-center border border-white/20">
                      {r?.gender === "M" ? <Mars size={16} /> : <Venus size={16} />}
                    </div>
                    <div className="flex-1 text-mute gps-mono text-xs">AWAITING SUBMISSION</div>
                  </div>
                )
              )}
            </GlassPanel>
          );
        })}
      </div>
    </div>
  );
}
